import { defaultLoggerConfig } from "../log";
import { balIconClose, balIconInfoCircle, balIconPlus, balIconMinus, balIconEdit, balIconTrash, balIconNavGoLeft, balIconNavGoRight, balIconNavGoDown, balIconNavGoUp, balIconCheck, balIconDate, balIconDocument, balIconUpload, balIconMenuBars, balIconFacebook, balIconInstagram, balIconLinkedin, balIconTwitter, balIconX, balIconXing, balIconYoutube, balIconWeb, balIconCaretDown, balIconCaretLeft, balIconCaretRight, balIconCaretUp, } from "../constants/icons.constant";
export const defaultIcons = {
    balIconClose,
    balIconInfoCircle,
    balIconPlus,
    balIconMinus,
    balIconEdit,
    balIconTrash,
    balIconNavGoLeft,
    balIconNavGoRight,
    balIconNavGoDown,
    balIconNavGoUp,
    balIconCheck,
    balIconDate,
    balIconDocument,
    balIconUpload,
    balIconMenuBars,
    balIconFacebook,
    balIconInstagram,
    balIconLinkedin,
    balIconTwitter,
    balIconX,
    balIconXing,
    balIconYoutube,
    balIconWeb,
    balIconCaretDown,
    balIconCaretLeft,
    balIconCaretRight,
    balIconCaretUp,
};
export const defaultConfig = {
    region: 'CH',
    language: 'de',
    allowedLanguages: ['de', 'fr', 'it', 'en'],
    icons: defaultIcons,
    fallbackLanguage: 'de',
    logger: defaultLoggerConfig,
    animated: true,
    httpFormSubmit: true,
};
export const defaultLocale = `${defaultConfig.language}-${defaultConfig.region}`;
